import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BrandedLoader from './ui/BrandedLoader';

const RootRedirect = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return <BrandedLoader title="Opening Advika OS" message="Loading your workspace entry point." />;

  return isAuthenticated
    ? <Navigate to="/dashboard" replace />
    : <Navigate to="/login" replace />;
};

export default RootRedirect;
